import { c as _c } from "react/compiler-runtime";
import { Alert } from 'design-system/server';
import { useTranslations, useLocale } from 'next-intl';
import styles from './PreviewModeWarning.module.css';
import Link from '@/components/Link';
import Routes from '@/helpers/utils/routing/Routes';
function PreviewModeWarning(t0) {
  const $ = _c(13);
  const {
    show,
    fundraisingEventId
  } = t0;
  const locale = useLocale();
  const t = useTranslations("nextjs.streambot.live_widgets.preview_mode");
  if (!show) {
    return null;
  }
  let t1;
  if ($[0] !== t) {
    t1 = t("warning_streambot");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== fundraisingEventId || $[3] !== locale) {
    t2 = Routes.fundraisingEventsManageLiveWidgets({
      locale,
      slug: fundraisingEventId,
      widget: ""
    });
    $[2] = fundraisingEventId;
    $[3] = locale;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("overview_link_label");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <Link href={t2} target="_blank">{t3}</Link>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t4) {
    t5 = <Alert kind="warning" size="small" icon={true} className={styles.previewModeWarning}>{t1}{" "}{t4}{" "}</Alert>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
export default PreviewModeWarning;